import React from 'react';

export interface SeatData {
  id: string;
  seatNumber: number;
  status: 'Available' | 'Assigned' | 'CheckedIn' | 'Held' | 'Blocked';
  guestId?: string | null;
  guestName?: string | null;
  protocolVip?: boolean;
  checkedIn?: boolean;
}

interface SeatDotProps {
  seat: SeatData;
  index: number;
  totalSeats: number;
  tableRadius: number;
  isHighlighted: boolean;
}

const SEAT_STATUS_COLORS: Record<string, string> = {
  Available: '#2e7d32',
  Assigned: '#1565c0',
  CheckedIn: '#6a1b9a',
  Held: '#e65100',
  Blocked: '#37474f',
};

function SeatDotInner({ seat, index, totalSeats, tableRadius, isHighlighted }: SeatDotProps) {
  const angle = (index / totalSeats) * 2 * Math.PI;
  const offset = 8; // distance from table edge to seat dot center
  const cx = Math.cos(angle) * (tableRadius + offset);
  const cy = Math.sin(angle) * (tableRadius + offset);
  const radius = Math.max(3, 8 - totalSeats * 0.4);
  const color = SEAT_STATUS_COLORS[seat.status] || '#999';
  const isFilled = seat.status !== 'Available';

  return (
    <circle
      cx={cx}
      cy={cy}
      r={radius}
      fill={isFilled ? color : 'none'}
      stroke={color}
      strokeWidth={isFilled ? 0 : 1.5}
      opacity={isHighlighted ? 1 : 0.85}
      filter={isHighlighted ? 'url(#seat-glow)' : undefined}
    >
      <title>
        Seat {seat.seatNumber}: {seat.status}
        {seat.guestName ? ` - ${seat.guestName}` : ''}
      </title>
    </circle>
  );
}

export const SeatDot = React.memo(SeatDotInner);
